export default __webpack_public_path__ + "static/media/ppt.7d2938bf.svg";